// Reveal hero videos on actual playback, not on load - avoids a blank flash.
const VIMEO_ORIGIN = 'https://player.vimeo.com'

function isVimeoIframe(iframe) {
  const src = iframe.getAttribute('src') || iframe.getAttribute('data-src-cmplz') || ''
  return src.includes('vimeo.com')
}

// Vimeo posts playback events via postMessage once asked - no SDK needed.
// The subscribe request itself can be missed if sent before the player's
// ready (or if the iframe was already loaded when we attach), so it's
// resent on an interval rather than gated behind a one-shot load event -
// harmless to repeat, and covers videos that were already playing.
function revealOnVimeoPlay(iframe) {
  const handleMessage = (event) => {
    if (event.origin !== VIMEO_ORIGIN || event.source !== iframe.contentWindow) {
      return
    }
    let data
    try {
      data = JSON.parse(event.data)
    } catch {
      return
    }
    if (data.event === 'play' || data.event === 'timeupdate') {
      window.removeEventListener('message', handleMessage)
      clearInterval(subscribeInterval)
      iframe.classList.add('is-loaded')
    }
  }
  window.addEventListener('message', handleMessage)

  const subscribe = () => {
    if (!iframe.contentWindow) {
      return
    }
    iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'play' }), VIMEO_ORIGIN)
    iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'timeupdate' }), VIMEO_ORIGIN)
  }
  subscribe()
  const subscribeInterval = setInterval(subscribe, 300)
  setTimeout(() => clearInterval(subscribeInterval), 10000)
}

// YouTube needs its IFrame API script for the same signal, so fall back to load.
function revealOnLoad(iframe) {
  iframe.addEventListener('load', () => {
    iframe.classList.add('is-loaded')
  }, { once: true })
}

function reveal(iframe) {
  if (isVimeoIframe(iframe)) {
    revealOnVimeoPlay(iframe)
  } else {
    revealOnLoad(iframe)
  }
}

export default function initHeroVideoReveal() {
  document.querySelectorAll('.video-iframe').forEach((iframe) => {
    if (!iframe.classList.contains('cmplz-iframe')) {
      reveal(iframe)
      return
    }

    // Gated iframes only get a real src once cmplz-activated is set.
    if (iframe.classList.contains('cmplz-activated')) {
      reveal(iframe)
      return
    }

    const observer = new MutationObserver(() => {
      if (iframe.classList.contains('cmplz-activated')) {
        reveal(iframe)
        observer.disconnect()
      }
    })
    observer.observe(iframe, { attributes: true, attributeFilter: ['class'] })
  })
}
